import { getSubdomain, fetchWithAuth } from "../helpers";
import { API_PASSWORD } from "../config";

// export const fetchInvoicesReport = async () => {
//   const subdomain = getSubdomain();
//   const url = `https://${subdomain}.restocash.app/api/get/all/invoices/1?api_password=${API_PASSWORD}`;

//   console.log("📡 إرسال طلب لجلب تقارير الفواتير:", url);

//   const response = await fetchWithAuth(url, {
//     method: "GET",
//     headers: {
//       "Content-Type": "application/json",
//     },
//   }, true); // ✅ استخدام التوكن

//   const result = await response.json();

//   if (!response.ok) {
//     console.error("❌ فشل في جلب تقارير الفواتير:", result);
//     throw new Error(result.message || "❌ فشل في جلب البيانات.");
//   }

//   console.log("✅ تقارير الفواتير:", result.data);
//   return result.data;
// };
export const fetchInvoicesReport = async () => {
  const subdomain = getSubdomain();
  const rootId = localStorage.getItem("branch_id"); // ✅ جلب الفرع من التخزين المحلي

  if (!rootId) {
    throw new Error("❌ لم يتم العثور على رقم الفرع (branch_id) في localStorage");
  }

  const url = `https://${subdomain}.restocash.app/api/get/all/invoices/${rootId}?api_password=${API_PASSWORD}`;

  console.log("📡 إرسال طلب لجلب تقارير الفواتير:", url);

  const response = await fetchWithAuth(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }, true); // ✅ استخدام التوكن

  const result = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في جلب تقارير الفواتير:", result);
    throw new Error(result.message || "❌ فشل في جلب البيانات.");
  }

  console.log("✅ تقارير الفواتير:", result.data);
  return result.data;
};
